import angular from 'angular';
import { BUREAU_NOME_MAX_LENGTH, IBureauForm } from '../models/bureaus.model';
import { MeurhBureausModalMode } from './bureaus.modal.service';
import { MeurhBureausService } from '../bureaus.service';

export class MeurhBureausModalController implements angular.IController {
    static $inject = ['entity', 'mode', '$uibModalInstance', 'MeurhBureausService', 'NewToaster'];

    public bureauForm: IBureauForm;
    public nomeOriginal: string;
    public form: angular.IFormController;
    public mode: MeurhBureausModalMode;
    public busy = false;
    public readonly nomeMaxLength = BUREAU_NOME_MAX_LENGTH;

    constructor(
        entity: IBureauForm,
        mode: MeurhBureausModalMode,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private meurhBureausService: MeurhBureausService,
        private NewToaster: any,
    ) {
        this.mode = mode;
        this.bureauForm = this.buildInitialBureau(entity);
        this.nomeOriginal = this.bureauForm.nome;
    }

    public modalTitle(): string {
        if (this.mode === 'create') {
            return 'Criar bureau';
        }

        return `Editar ${this.nomeOriginal || 'bureau'}`;
    }

    public submitLabel(): string {
        return this.mode === 'create' ? 'Criar bureau' : 'Salvar alterações';
    }

    public onNomeChange(): void {
        this.validateNomeField();
    }

    public salvar(form?: angular.IFormController): void {
        this.validateNomeField();

        if (form && form.$invalid) {
            return;
        }

        const nome = (this.bureauForm.nome || '').trim();
        if (!nome) {
            return;
        }

        this.busy = true;

        const request: angular.IPromise<any> = this.mode === 'create'
            ? this.meurhBureausService.create(nome)
            : this.meurhBureausService.update(this.bureauForm.bureau, nome);

        request
            .then((resultado) => {
                this.NewToaster.pop({
                    type: 'success',
                    title: this.mode === 'create'
                        ? 'Bureau criado com sucesso!'
                        : 'Bureau atualizado com sucesso!'
                });

                this.$uibModalInstance.close(resultado);
            })
            .catch((error) => {
                this.NewToaster.pop({
                    type: 'error',
                    title: this.mode === 'create'
                        ? 'Erro ao criar bureau'
                        : 'Erro ao atualizar bureau',
                    body: error?.data?.message || (this.mode === 'create'
                        ? 'Ocorreu um erro ao criar o bureau.'
                        : 'Ocorreu um erro ao atualizar o bureau.')
                });
            })
            .finally(() => {
                this.busy = false;
            });
    }

    public cancelar(): void {
        this.$uibModalInstance.dismiss('cancel');
    }

    private buildInitialBureau(entity: IBureauForm): IBureauForm {
        const bureau: Partial<IBureauForm> = entity ? angular.copy(entity) : {};

        return {
            ...bureau,
            nome: bureau.nome || '',
        };
    }

    /** O `required` do Angular aceita `"   "`; a validação após `trim` fecha essa brecha. */
    private validateNomeField(): void {
        if (!this.form?.nome?.$setValidity) {
            return;
        }

        this.form.nome.$setValidity('trimmedRequired', !!(this.bureauForm.nome || '').trim());
    }
}
